import { render, staticRenderFns } from "./PhoneLinkField.vue?vue&type=template&id=48c95487&"
import script from "./PhoneLinkField.vue?vue&type=script&lang=ts&"
export * from "./PhoneLinkField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports